import { ErrorBoundary } from '@components/error';
import { message } from 'antd';
import { Translate } from 'next-translate';
import { extractErrorMessage } from './extractErrorMessage';

type TOptionsWithToast = {
  t?: Translate | null;
  showToast?: true;
};

type TOptionsWithoutToast = {
  t?: Translate | null;
  showToast: false;
};

type TOptions = TOptionsWithToast | TOptionsWithoutToast;

export const handleError = (err: any, opts: TOptions) => {
  const { t, showToast = true } = opts;

  console.error(err);
  if (ErrorBoundary.bugsnagClient) {
    ErrorBoundary.bugsnagClient.notify(err);
  }

  const msg = extractErrorMessage(err);

  if (t && showToast) {
    message.error(t(`error:${msg}`, null, { fallback: msg }));
  }
};
